import api from './api';
import { DACA } from '../constants/apiRoutes';

export default {
	findById(id) {
		return api.get(DACA.FIND_ID.replace('{id}', id));
	},
	editarItemDaca(values) {
		return api.post(DACA.FIND_ALL, values);
	},
	findByIdAndHistorico(id, historicoDaca, tipoQuantidadeEstoqueDACA) {
		return api.get(DACA.TIPO_TRANSACAO.replace('{id}', id)
										  .replace('{historicoDaca}', historicoDaca)
										  .replace('{tipoQuantidadeEstoqueDACA}', tipoQuantidadeEstoqueDACA));
	},
	devolucaoItemDaca(devolucao) {
		return api.post(DACA.HISTORICO_DEVOLUCAO, devolucao);
	},
	editarTransacaoEntrada(transacao) {
		return api.post(DACA.EDITAR_ENTRADA, transacao);
	},
	editarTransacaoSaida(transacao) {
		return api.post(DACA.EDITAR_SAIDA, transacao);
	},
	editarTransacaoMovimentacao(transacao) {
		return api.post(DACA.EDITAR_MOVIMENTACAO, transacao);
	},
	editarTransacaoDevolucao(transacao) {
		return api.post(DACA.EDITAR_DEVOLUCAO, transacao);
	},
	cancelarTransacao(transacao) {
		return api.post(DACA.CANCELAR_TRANSACAO, transacao);
	},
};
